import { LOADER_CONST } from './Loader.d';
import { LoaderFullScreen } from './Loader.styles';
import Loader from './Loader';
import type { LoaderFullScreenProps } from './Loader.d';

const LoaderFullScreenBase = ({ message }: LoaderFullScreenProps) => (
  <LoaderFullScreen.Wrapper data-testid={LOADER_CONST.FULLSCREEN_TEST_ID}>
    <LoaderFullScreen.Loader>
      <Loader />
    </LoaderFullScreen.Loader>
    <LoaderFullScreen.Message>{message}</LoaderFullScreen.Message>
  </LoaderFullScreen.Wrapper>
);

export default LoaderFullScreenBase;
